const PROJECT_ID = process.env.REACT_APP_PROJECT_ID;

function parseFirestoreValue(value) {
  if (!value) return null;
  if ("stringValue" in value) return value.stringValue;
  if ("booleanValue" in value) return value.booleanValue;
  if ("integerValue" in value) return parseInt(value.integerValue, 10);
  if ("doubleValue" in value) return value.doubleValue;
  if ("arrayValue" in value) {
    return (value.arrayValue.values || []).map((v) => {
      if (v.mapValue) return parseFirestoreMap(v.mapValue.fields || {});
      return parseFirestoreValue(v);
    });
  }
  if ("mapValue" in value) return parseFirestoreMap(value.mapValue.fields || {});
  return null;
}

function parseFirestoreMap(fields) {
  const result = {};
  for (const [key, val] of Object.entries(fields)) {
    result[key] = parseFirestoreValue(val);
  }
  return result;
}

async function fetchCollection(collectionName) {
  const url = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/${collectionName}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Firestore REST error: ${res.status}`);
  const data = await res.json();
  if (!data.documents) return [];
  return data.documents.map((doc) => {
    const id = doc.name.split("/").pop();
    return { id, ...parseFirestoreMap(doc.fields || {}) };
  });
}

export async function fetchSliders() {
  return fetchCollection("sliders-ford");
}

export async function fetchFinanciaciones() {
  const url = `https://firestore.googleapis.com/v1/projects/${PROJECT_ID}/databases/(default)/documents/financiaciones/datos`;
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Firestore REST error: ${res.status}`);
  const data = await res.json();
  const fields = parseFirestoreMap(data.fields || {});
  return fields.datos || [];
}

